export default __webpack_public_path__ + "static/media/Help.7570c30c.svg";